import { Box, Tab, LinearProgress } from "@mui/material";
import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import "../assets/css/accountmetrics.scss";
import ProgramObjectives from "../components/Accountmetrics/ProgramObjectivesNew";
import AdvancedInsights from "../components/Accountmetrics/AdvancedInsights";
import TradingJournal from "../components/Accountmetrics/TradingJournal";
import AccInfo from "../components/Accountmetrics/AccInfo";
import Loader from "../reusableComponents/Loader";
import {
  fetchTraderJournal,
  fetchPerformanceChart,
  fetchAccountDetails,
  fetchAccountInsights,
  removeDashboard,
  setLinkGeneratedReducer,
} from "../store/reducers/dashboardReducer";
import { LoadUser } from "../store/reducers/userProfileReducer";
import NewTradingHistory from "../components/Accountmetrics/NewTradingHistory";
import NewAccInfo from "../components/Accountmetrics/NewAccInfo";
import AccountAnalysis from "./AccountAnalysis";
import MobileTabs from "../reusableComponents/MobileTabs/MobileTabs";
import { ReactComponent as ShareBtnIcon } from "../assets/icons/NewIcons/shareBtnIcon.svg";
import { ReactComponent as CopiedIcon } from "../assets/icons/NewIcons/copiedIcon.svg";
import { ReactComponent as CloseIcon } from "../assets/icons/NewIcons/exittIcon.svg";
import CopyToClipboard from "react-copy-to-clipboard";
import { handleCopyToClipboard } from "../utilities/string";
import { fetchMetricsTabs, updateAccount } from "../utilities/PublicShare";
import Spinner from "../reusableComponents/Spinner";
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  LinkedinShareButton,
  TelegramShareButton,
  RedditShareButton,
  EmailShareButton,
  XShareButton, // Added for X (formerly Twitter)
  FacebookIcon,
  TwitterIcon,
  WhatsappIcon,
  LinkedinIcon,
  TelegramIcon,
  RedditIcon,
  EmailIcon,
  XIcon, // Added for X (formerly Twitter)
} from "react-share";

const renderPermissions = (payload, setPayload) => {
  return (
    <div className="tabs_checkbox">
      <div className="TandC">
        <input
          type="checkbox"
          value={1}
          checked={payload.includes(1)} // Set checked if 1 is in payload
          onChange={(e) => {
            setPayload(
              (prev) =>
                e.target.checked
                  ? [...prev, 1] // Add to payload when checked
                  : prev.filter((item) => item !== 1) // Remove from payload when unchecked
            );
          }}
          style={{ marginTop: "3px" }}
        />
        <p>Program Objective</p>
      </div>
      <div className="TandC">
        <input
          type="checkbox"
          value={2}
          checked={payload.includes(2)} // Set checked if 2 is in payload
          onChange={(e) => {
            setPayload((prev) =>
              e.target.checked
                ? [...prev, 2]
                : prev.filter((item) => item !== 2)
            );
          }}
          style={{ marginTop: "3px" }}
        />
        <p>Advanced Insights</p>
      </div>
      <div className="TandC">
        <input
          type="checkbox"
          value={3}
          checked={payload.includes(3)} // Set checked if 3 is in payload
          onChange={(e) => {
            setPayload((prev) =>
              e.target.checked
                ? [...prev, 3]
                : prev.filter((item) => item !== 3)
            );
          }}
          style={{ marginTop: "3px" }}
        />
        <p>Trading History</p>
      </div>
      <div className="TandC">
        <input
          type="checkbox"
          value={4}
          checked={payload.includes(4)} // Set checked if 4 is in payload
          onChange={(e) => {
            setPayload((prev) =>
              e.target.checked
                ? [...prev, 4]
                : prev.filter((item) => item !== 4)
            );
          }}
          style={{ marginTop: "3px" }}
        />
        <p>Account Analysis</p>
      </div>
    </div>
  );
};

const AccountMetric = () => {
  const [value, setValue] = useState("1");
  const [CurrentAcc, setCurrentAcc] = useState(false);
  const [CurrentPltform, setCurrentPltform] = useState(false);
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.dashboard.loading);
  const [refreshData, setRefreshData] = useState(false);

  const loader = useSelector((state) => state.loader.is_loading);
  const [open, setOpen] = useState(true);
  useEffect(() => {
    setOpen(loader);
  }, [loader]);

  const performance_chart = useSelector(
    (state) => state.dashboard.SavePerformance
  );
  const performance_char = useSelector((state) => state);

  const TradeJournalNew = useSelector((state) => state.dashboard.TradeJournal);

  const { AccDetails, accountInsights } = useSelector(
    (state) => state.dashboard
  );
  console.log(AccDetails, "AccDetailsAccDetails");

  let interval = useRef(null);

  useEffect(() => {
    if (CurrentAcc) {
      dispatch(LoadUser());
      dispatch(fetchAccountDetails(CurrentAcc, CurrentPltform));
      dispatch(fetchPerformanceChart(CurrentAcc, CurrentPltform));
      dispatch(fetchTraderJournal(CurrentAcc, CurrentPltform));
      dispatch(fetchAccountInsights(CurrentAcc, CurrentPltform));

      // interval.current = setInterval(() => {
      //   dispatch(LoadUser());
      //   dispatch(fetchTraderJournal(CurrentAcc, CurrentPltform));
      //   dispatch(fetchAccountDetails(CurrentAcc, CurrentPltform));
      //   dispatch(fetchPerformanceChart(CurrentAcc, CurrentPltform));
      //   dispatch(fetchAccountInsights(CurrentAcc, CurrentPltform));
      // }, 30 * 1000);
    }
    return () => {
      dispatch(removeDashboard());
      clearInterval(interval.current);
    };
  }, [dispatch, CurrentPltform, CurrentAcc]);

  // CurrentAcc, CurrentPltform

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const user_profile = useSelector((state) => state.user);

  useEffect(() => {
    if (Object.keys(user_profile).length) {
      if (user_profile.current_account) {
        setCurrentAcc(user_profile.current_account);
        setCurrentPltform(user_profile.current_platform);
      }
    }
  }, [user_profile]);

  const [profileActive, setProfileActive] = useState(1);
  const [mainTabination, setMainTabination] = useState(1);
  const [activeTab, setActiveTab] = useState(mainTabination);

  useEffect(() => {
    setMainTabination(activeTab);
  }, [activeTab]);
  const tabItems = [
    {
      name: "Program Objectives",
      value: 1,
    },
    {
      name: "Advanced Insights",
      value: 2,
    },
    {
      name: "Trading History",
      value: 3,
    },
    {
      name: "Account Analysis",
      value: 4,
    },
    {
      name: "Account Info",
      value: 5,
    },
  ];

  const dropDownRef = useRef(null);
  const [shareDropdown, setShareDropdown] = useState(false);
  const [linkGenerated, setLinkGenerated] = useState(false);
  const [linkCopied, setLinkCopied] = useState(false);
  const [publicShareLink, setPublicShareLink] = useState("");

  console.log("linkGenerated", linkGenerated);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropDownRef.current && !dropDownRef.current.contains(event.target)) {
        setShareDropdown(false);
      }
    };

    // Add event listener for clicks
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleShare = () => {
    setShareDropdown(true);
  };

  const [buttonLoader, isButtonLoader] = useState(false);
  const [payload, setPayload] = useState([]);

  const handleGenerate = async (isPublic, status) => {
    isButtonLoader(status);
    const data = {
      public: isPublic,
      public_permissions: isPublic ? payload : [],
    }; // Boolean value, not string
    if (!AccDetails?.login_id) {
      console.error("Login ID is not available");
      return;
    }
    try {
      const result = await updateAccount(AccDetails.login_id, data, idToken);
      dispatch(fetchAccountDetails(CurrentAcc, CurrentPltform));
      console.log("API Result:", result);
      if (result.success) {
        setLinkGenerated(true);
        // dispatch(setLinkGeneratedReducer(true));
      } else {
        alert(`Failed to update account: ${result.error}`);
      }
      isButtonLoader(false);
    } catch (error) {
      isButtonLoader(false);
      console.error("Error updating account:", error);
    } finally {
      isButtonLoader(false);
    }
  };

  const copyLink = () => {
    setLinkCopied(true);
    setTimeout(() => {
      setLinkCopied(false);
    }, 2000);
  };
  const idToken = useSelector((state) => state.ACCtoken);

  const [permissionTabs, setPermissionTabs] = useState([]);
  const [isloadings, setIsloadings] = useState(false);
  console.log(payload, "permissionTabspermissionTabs");

  const getMetricsTabs = async () => {
    try {
      const response = await fetchMetricsTabs(CurrentAcc);
      if (response?.success && Array.isArray(response.data)) {
        setPermissionTabs(response.data);
        setPayload(
          response.data.map((item) => {
            return item.id;
          })
        );
      } else {
        console.error(
          "Invalid response format or unsuccessful request:",
          response
        );
      }
    } catch (error) {
      console.error("Error fetching metrics tabs:", error);
    } finally {
      setIsloadings(false);
    }
  };

  useEffect(() => {
    CurrentAcc && getMetricsTabs();
  }, [CurrentAcc]);

  return (
    <div
      className="AccountMetricsContainer PageContainer"
      style={{ position: "relative" }}
    >
      {mainTabination != 4 && <Loader open={open} />}
      {/* {loading ? <LinearProgress /> : false} */}

      <div className="accntMetricsHeader">
        <div className="newTabination">
          <div
            onClick={() => {
              setMainTabination(1);
            }}
            className={
              "newTabination-item " + (mainTabination === 1 && " active ")
            }
          >
            <div className="svg-con">
              <svg
                width="22"
                height="20"
                viewBox="0 0 22 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2 20C1.45 20 0.979002 19.804 0.587002 19.412C0.195002 19.02 -0.000664969 18.5493 1.69779e-06 18V4C1.69779e-06 3.45 0.196002 2.979 0.588002 2.587C0.980002 2.195 1.45067 1.99933 2 2H10V4H2V18H16V12H18V18C18 18.55 17.804 19.021 17.412 19.413C17.02 19.805 16.5493 20.0007 16 20H2ZM4 16H6V9H4V16ZM8 16H10V6H8V16ZM12 16H14V12H12V16ZM17 10C16.5 10 16.0083 9.925 15.525 9.775C15.0417 9.625 14.5917 9.40833 14.175 9.125L13.8 9.475C13.6 9.65833 13.3623 9.75 13.087 9.75C12.8117 9.75 12.5827 9.65833 12.4 9.475C12.2167 9.29167 12.125 9.05833 12.125 8.775C12.125 8.49167 12.2167 8.25833 12.4 8.075L12.8 7.675C12.5333 7.275 12.3333 6.85 12.2 6.4C12.0667 5.95 12 5.48333 12 5C12 3.61667 12.4877 2.43767 13.463 1.463C14.4383 0.488333 15.6173 0.000666667 17 0H22V5C22 6.38333 21.5123 7.56267 20.537 8.538C19.5617 9.51333 18.3827 10.0007 17 10ZM17 8C17.8333 8 18.5417 7.70833 19.125 7.125C19.7083 6.54167 20 5.83333 20 5V2H17C16.1667 2 15.4583 2.29167 14.875 2.875C14.2917 3.45833 14 4.16667 14 5C14 5.21667 14.021 5.425 14.063 5.625C14.105 5.825 14.1673 6.025 14.25 6.225L16.85 3.625C17.0333 3.44167 17.2667 3.35 17.55 3.35C17.8333 3.35 18.0667 3.44167 18.25 3.625C18.45 3.825 18.55 4.06267 18.55 4.338C18.55 4.61333 18.45 4.85067 18.25 5.05L15.65 7.65C15.8667 7.75 16.0877 7.83333 16.313 7.9C16.5383 7.96667 16.7673 8 17 8Z"
                  fill="white"
                />
              </svg>
            </div>
            Program Objectives
          </div>

          <>
            <div
              onClick={() => {
                setMainTabination(2);
              }}
              className={
                "newTabination-item " + (mainTabination === 2 && " active ")
              }
            >
              <div className="svg-con">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21 8C19.55 8 18.74 9.44 19.07 10.51L15.52 14.07C15.22 13.98 14.78 13.98 14.48 14.07L11.93 11.52C12.27 10.45 11.46 9 10 9C8.55 9 7.73 10.44 8.07 11.52L3.51 16.07C2.44 15.74 1 16.55 1 18C1 19.1 1.9 20 3 20C4.45 20 5.26 18.56 4.93 17.49L9.48 12.93C9.78 13.02 10.22 13.02 10.52 12.93L13.07 15.48C12.73 16.55 13.54 18 15 18C16.45 18 17.27 16.56 16.93 15.48L20.49 11.93C21.56 12.26 23 11.45 23 10C23 8.9 22.1 8 21 8Z"
                    fill="white"
                  />
                  <path
                    d="M15 9L15.94 6.93L18 6L15.94 5.07L15 3L14.08 5.07L12 6L14.08 6.93L15 9ZM3.5 11L4 9L6 8.5L4 8L3.5 6L3 8L1 8.5L3 9L3.5 11Z"
                    fill="white"
                  />
                </svg>
              </div>
              Advanced Insights
            </div>
          </>

          <>
            <div
              onClick={() => {
                setMainTabination(3);
              }}
              className={
                "newTabination-item " + (mainTabination === 3 && " active ")
              }
            >
              <div className="svg-con">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask
                    id="path-1-outside-1_220_9799"
                    maskUnits="userSpaceOnUse"
                    x="2"
                    y="1"
                    width="21"
                    height="21"
                    fill="black"
                  >
                    <rect fill="white" x="2" y="1" width="21" height="21" />
                    <path d="M19 4C19 4.55228 19.4477 5 20 5C20.5523 5 21 4.55228 21 4C21 3.44772 20.5523 3 20 3C19.4477 3 19 3.44772 19 4Z" />
                  </mask>
                  <path
                    d="M15 3.75C15.4142 3.75 15.75 3.41421 15.75 3C15.75 2.58579 15.4142 2.25 15 2.25V3.75ZM21.75 9C21.75 8.58579 21.4142 8.25 21 8.25C20.5858 8.25 20.25 8.58579 20.25 9H21.75ZM5.06107 20.0451L4.62023 20.6518L4.62024 20.6518L5.06107 20.0451ZM3.95491 18.9389L4.56168 18.4981H4.56168L3.95491 18.9389ZM18.9389 20.0451L19.3798 20.6518H19.3798L18.9389 20.0451ZM20.0451 18.9389L20.6518 19.3798V19.3798L20.0451 18.9389ZM3.95491 5.06107L3.34815 4.62023L3.34815 4.62023L3.95491 5.06107ZM5.06107 3.95491L4.62023 3.34815L4.62023 3.34815L5.06107 3.95491ZM6.32665 14.5268C6.14423 14.8987 6.29782 15.3481 6.6697 15.5305C7.04158 15.7129 7.49093 15.5593 7.67335 15.1874L6.32665 14.5268ZM8.46033 11.8801L9.13368 12.2104L8.46033 11.8801ZM15.5397 12.1199L16.213 12.4502L15.5397 12.1199ZM17.6734 9.47316C17.8558 9.10127 17.7022 8.65192 17.3303 8.46951C16.9584 8.28709 16.5091 8.44068 16.3266 8.81256L17.6734 9.47316ZM12 12L11.3058 12.284L12 12ZM12 3.75H15V2.25H12V3.75ZM20.25 9V12H21.75V9H20.25ZM12 20.25C10.1084 20.25 8.74999 20.249 7.69804 20.135C6.66013 20.0225 6.00992 19.8074 5.50191 19.4383L4.62024 20.6518C5.42656 21.2377 6.37094 21.5 7.53648 21.6263C8.68798 21.751 10.1418 21.75 12 21.75V20.25ZM2.25 12C2.25 13.8582 2.24897 15.312 2.37373 16.4635C2.50001 17.6291 2.76232 18.5734 3.34815 19.3798L4.56168 18.4981C4.19259 17.9901 3.97745 17.3399 3.865 16.302C3.75103 15.25 3.75 13.8916 3.75 12H2.25ZM5.50191 19.4383C5.14111 19.1762 4.82382 18.8589 4.56168 18.4981L3.34815 19.3798C3.70281 19.8679 4.13209 20.2972 4.62023 20.6518L5.50191 19.4383ZM12 21.75C13.8582 21.75 15.312 21.751 16.4635 21.6263C17.6291 21.5 18.5734 21.2377 19.3798 20.6518L18.4981 19.4383C17.9901 19.8074 17.3399 20.0225 16.302 20.135C15.25 20.249 13.8916 20.25 12 20.25V21.75ZM20.25 12C20.25 13.8916 20.249 15.25 20.135 16.302C20.0225 17.3399 19.8074 17.9901 19.4383 18.4981L20.6518 19.3798C21.2377 18.5734 21.5 17.6291 21.6263 16.4635C21.751 15.312 21.75 13.8582 21.75 12H20.25ZM19.3798 20.6518C19.8679 20.2972 20.2972 19.8679 20.6518 19.3798L19.4383 18.4981C19.1762 18.8589 18.8589 19.1762 18.4981 19.4383L19.3798 20.6518ZM3.75 12C3.75 10.1084 3.75103 8.74999 3.865 7.69805C3.97745 6.66013 4.19259 6.00992 4.56168 5.50191L3.34815 4.62023C2.76232 5.42656 2.50001 6.37094 2.37373 7.53648C2.24897 8.68798 2.25 10.1418 2.25 12H3.75ZM12 2.25C10.1418 2.25 8.68798 2.24897 7.53648 2.37373C6.37094 2.50001 5.42656 2.76232 4.62023 3.34815L5.50191 4.56168C6.00992 4.19259 6.66013 3.97745 7.69805 3.865C8.74999 3.75103 10.1084 3.75 12 3.75V2.25ZM4.56168 5.50191C4.82382 5.14111 5.14111 4.82382 5.50191 4.56168L4.62023 3.34815C4.13209 3.70281 3.70281 4.13209 3.34815 4.62023L4.56168 5.50191ZM7.67335 15.1874L9.13368 12.2104L7.78698 11.5498L6.32665 14.5268L7.67335 15.1874ZM16.213 12.4502L17.6734 9.47316L16.3266 8.81256L14.8663 11.7896L16.213 12.4502ZM11.3058 12.284C12.185 14.433 15.1904 14.5348 16.213 12.4502L14.8663 11.7896C14.4137 12.7124 13.0833 12.6673 12.6942 11.716L11.3058 12.284ZM9.13368 12.2104C9.58632 11.2876 10.9167 11.3327 11.3058 12.284L12.6942 11.716C11.815 9.56698 8.80955 9.46517 7.78698 11.5498L9.13368 12.2104ZM17.5 4C17.5 5.38071 18.6193 6.5 20 6.5V3.5C20.2761 3.5 20.5 3.72386 20.5 4H17.5ZM20 6.5C21.3807 6.5 22.5 5.38071 22.5 4H19.5C19.5 3.72386 19.7239 3.5 20 3.5V6.5ZM22.5 4C22.5 2.61929 21.3807 1.5 20 1.5V4.5C19.7239 4.5 19.5 4.27614 19.5 4H22.5ZM20 1.5C18.6193 1.5 17.5 2.61929 17.5 4H20.5C20.5 4.27614 20.2761 4.5 20 4.5V1.5Z"
                    fill="white"
                    mask="url(#path-1-outside-1_220_9799)"
                  />
                </svg>
              </div>
              Trading History
            </div>
          </>

          <>
            <div
              onClick={() => {
                setMainTabination(4);
              }}
              className={
                "newTabination-item " + (mainTabination === 4 && " active ")
              }
            >
              <div className="svg-con">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.74 15.75H20C20.7292 15.7495 21.4283 15.4596 21.944 14.944C22.4596 14.4283 22.7495 13.7292 22.75 13V4C22.7495 3.27082 22.4596 2.57165 21.944 2.05604C21.4283 1.54043 20.7292 1.25053 20 1.25H9C8.27082 1.25053 7.57165 1.54043 7.05604 2.05604C6.54043 2.57165 6.25053 3.27082 6.25 4V5.08C6.25 5.27891 6.32902 5.46968 6.46967 5.61033C6.61032 5.75098 6.80109 5.83 7 5.83C7.19891 5.83 7.38968 5.75098 7.53033 5.61033C7.67098 5.46968 7.75 5.27891 7.75 5.08V4C7.75053 3.66864 7.8824 3.35101 8.1167 3.1167C8.35101 2.88239 8.66864 2.75053 9 2.75H20C20.3314 2.75053 20.649 2.88239 20.8833 3.1167C21.1176 3.35101 21.2495 3.66864 21.25 4V13C21.2495 13.3314 21.1176 13.649 20.8833 13.8833C20.649 14.1176 20.3314 14.2495 20 14.25H11.74C11.5411 14.25 11.3503 14.329 11.2097 14.4697C11.069 14.6103 10.99 14.8011 10.99 15C10.99 15.1989 11.069 15.3897 11.2097 15.5303C11.3503 15.671 11.5411 15.75 11.74 15.75Z"
                    fill="white"
                  />
                  <path
                    d="M10.583 10.6234C10.7062 10.7058 10.8511 10.7498 10.9993 10.75C11.0978 10.7502 11.1954 10.7309 11.2864 10.6931C11.3774 10.6554 11.46 10.5999 11.5293 10.53L13.9993 8.06097L15.4683 9.53297C15.5412 9.6065 15.6285 9.6641 15.7248 9.70211C15.821 9.74011 15.9242 9.7577 16.0276 9.75375C16.131 9.7498 16.2325 9.7244 16.3256 9.67917C16.4187 9.63393 16.5013 9.56984 16.5683 9.49097L19.5683 5.99097C19.6902 5.83914 19.7483 5.64588 19.7302 5.45202C19.7122 5.25817 19.6195 5.07893 19.4717 4.95218C19.3239 4.82544 19.1327 4.76113 18.9383 4.77284C18.744 4.78456 18.5618 4.87139 18.4303 5.01497L15.9573 7.89997L14.5293 6.46997C14.4598 6.40031 14.3772 6.34504 14.2862 6.30733C14.1953 6.26962 14.0978 6.25022 13.9993 6.25022C13.9009 6.25022 13.8034 6.26962 13.7125 6.30733C13.6215 6.34504 13.5389 6.40031 13.4693 6.46997L10.4693 9.46997C10.3646 9.57486 10.2933 9.70844 10.2644 9.85383C10.2355 9.99923 10.2503 10.1499 10.3071 10.2869C10.3638 10.4239 10.4598 10.5409 10.583 10.6234Z"
                    fill="white"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M3 22.75C2.53603 22.7495 2.09122 22.5649 1.76315 22.2369C1.43507 21.9088 1.25053 21.464 1.25 21V19C1.25 17.7402 1.75044 16.532 2.64124 15.6412C2.90752 15.375 3.20216 15.1436 3.51805 14.95C2.8771 14.4889 2.37641 13.8577 2.07351 13.1264C1.75184 12.3498 1.66768 11.4953 1.83166 10.6709C1.99565 9.84645 2.40042 9.08917 2.9948 8.4948C3.58917 7.90042 4.34645 7.49565 5.17087 7.33166C5.99529 7.16768 6.84982 7.25184 7.62641 7.57351C8.40299 7.89519 9.06675 8.43992 9.53375 9.13883C10.0007 9.83774 10.25 10.6594 10.25 11.5C10.2487 12.6268 9.80049 13.707 9.00374 14.5037C8.84044 14.6671 8.66522 14.8157 8.48014 14.9489C8.79672 15.1427 9.09197 15.3745 9.35876 15.6412C10.2496 16.532 10.75 17.7402 10.75 19V21C10.7495 21.464 10.5649 21.9088 10.2369 22.2369C9.90878 22.5649 9.46397 22.7495 9 22.75H3ZM6 15.75C5.99976 15.75 6.00024 15.75 6 15.75C5.99959 15.75 5.99919 15.75 5.99878 15.75C5.13759 15.7514 4.31205 16.0941 3.70307 16.7031C3.09381 17.3123 2.75106 18.1384 2.75 19V21C2.75 21.0663 2.77634 21.1299 2.82322 21.1768C2.87011 21.2237 2.9337 21.25 3 21.25H9C9.0663 21.25 9.12989 21.2237 9.17678 21.1768C9.22366 21.1299 9.25 21.0663 9.25 21V19C9.24894 18.1384 8.90619 17.3123 8.29693 16.7031C7.68784 16.094 6.86136 15.7513 6 15.75ZM6.00324 14.25C6.36155 14.2496 6.71813 14.1791 7.05238 14.0407C7.55488 13.8325 7.98437 13.4801 8.28654 13.0278C8.58872 12.5756 8.75 12.0439 8.75 11.5C8.74947 10.7708 8.45957 10.0717 7.94396 9.55604C7.42835 9.04043 6.72918 8.75053 6 8.75C5.4561 8.75 4.92442 8.91129 4.47218 9.21346C4.01995 9.51563 3.66747 9.94513 3.45933 10.4476C3.25119 10.9501 3.19673 11.5031 3.30284 12.0365C3.40895 12.5699 3.67086 13.06 4.05546 13.4445C4.44005 13.8291 4.93006 14.0911 5.4635 14.1972C5.64211 14.2327 5.82289 14.2502 6.00324 14.25Z"
                    fill="white"
                  />
                </svg>
              </div>
              Account Analysis
            </div>
          </>

          <>
            <div
              onClick={() => {
                setMainTabination(5);
              }}
              className={
                "newTabination-item " + (mainTabination === 5 && " active ")
              }
            >
              <div className="svg-con">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.25 6C15.25 7.79493 13.7949 9.25 12 9.25V10.75C14.6234 10.75 16.75 8.62335 16.75 6H15.25ZM12 9.25C10.2051 9.25 8.75 7.79493 8.75 6H7.25C7.25 8.62335 9.37665 10.75 12 10.75V9.25ZM8.75 6C8.75 4.20507 10.2051 2.75 12 2.75V1.25C9.37665 1.25 7.25 3.37665 7.25 6H8.75ZM12 2.75C13.7949 2.75 15.25 4.20507 15.25 6H16.75C16.75 3.37665 14.6234 1.25 12 1.25V2.75ZM9 13.75H15V12.25H9V13.75ZM15 20.25H9V21.75H15V20.25ZM9 20.25C7.20507 20.25 5.75 18.7949 5.75 17H4.25C4.25 19.6234 6.37665 21.75 9 21.75V20.25ZM18.25 17C18.25 18.7949 16.7949 20.25 15 20.25V21.75C17.6234 21.75 19.75 19.6234 19.75 17H18.25ZM15 13.75C16.7949 13.75 18.25 15.2051 18.25 17H19.75C19.75 14.3766 17.6234 12.25 15 12.25V13.75ZM9 12.25C6.37665 12.25 4.25 14.3766 4.25 17H5.75C5.75 15.2051 7.20507 13.75 9 13.75V12.25Z"
                    fill="#E6FBFF"
                  />
                </svg>
              </div>
              Account Info
            </div>
          </>
        </div>
        <div className="mobileTabOption">
          <MobileTabs
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            tabItems={tabItems}
          />
        </div>
        <div className="shareBtn" ref={dropDownRef}>
          <button onClick={handleShare}>
            <ShareBtnIcon />
            Share
          </button>

          <div
            className={`shareDropDown ${
              shareDropdown ? "dropdownVisible" : "dropdownHidden"
            }`}
          >
            <div className="shareHeader">
              Share
              <button>
                <CloseIcon onClick={() => setShareDropdown(false)} />
              </button>
            </div>
            <div>
              <div className="generateBtn">
                {/* AccDetails and linkGenerated are expected props or state */}
                {!linkGenerated && !AccDetails?.public ? (
                  <>
                    <p>Link not generated before. To share, generate a link.</p>
                    {renderPermissions(payload, setPayload)}
                  </>
                ) : (
                  <>
                    <p>
                      {!AccDetails?.public
                        ? "Generate the Link. Click Copy Link and share"
                        : "Link Generated Successfully. Click Copy Link and share"}
                      {renderPermissions(payload, setPayload)}
                    </p>

                    {AccDetails?.public && <p>{"You can disable the Link"}</p>}
                  </>
                )}
                {!AccDetails?.public ? (
                  <button
                    className={`generate_btn`}
                    onClick={() => handleGenerate(true, "Generate")}
                    disabled={payload.length === 0}
                    style={{backgroundColor:payload.length === 0&&"gray"}}
                  >
                    {buttonLoader === "Generate" ? <Spinner /> : "Generate"}
                  </button>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: "20px",
                    }}
                  >
                    <button
                      className={`generate_btn`}
                      onClick={() => handleGenerate(true, "Update Permissions")}
                      disabled={payload.length === 0}
                      style={{backgroundColor:payload.length === 0&&"gray"}}
                    >
                      {buttonLoader === "Update Permissions" ? (
                        <Spinner />
                      ) : (
                        "Update Permissions"
                      )}
                      
                    </button>
                    <button
                      className={`disable_btn`}
                      onClick={() => {
                        handleGenerate(false, "Disable");
                        setPayload([]);
                      }}
                    >
                      {buttonLoader === "Disable" ? <Spinner /> : "Disable"}
                    </button>
                  </div>
                )}
              </div>
            </div>

            {AccDetails?.public ? (
              <div className="generatedLink">
                <p>
                  {window.location.origin +
                    `/share/${AccDetails?.platform}/${AccDetails?.login_id}`}
                </p>
                <CopyToClipboard
                  onCopy={() => handleCopyToClipboard("Link Copied!")}
                  text={
                    window.location.origin +
                    `/share/${AccDetails?.platform}/${AccDetails?.login_id}`
                  }
                >
                  <button onClick={copyLink}>
                    {!linkCopied ? (
                      "Copy Link"
                    ) : (
                      <>
                        Copied <CopiedIcon />
                      </>
                    )}
                  </button>
                </CopyToClipboard>
              </div>
            ) : (
              <></>
            )}
            {AccDetails?.public && (
              <div className="generatedLink social_icons">
                <FacebookShareButton
                  url={
                    window.location.origin +
                    `/share/${AccDetails?.platform}/${AccDetails?.login_id}`
                  }
                  quote={""}
                >
                  <FacebookIcon size={32} round />
                </FacebookShareButton>

                {/* Twitter (X) */}
                <TwitterShareButton
                  url={
                    window.location.origin +
                    `/share/${AccDetails?.platform}/${AccDetails?.login_id}`
                  }
                  title={""}
                >
                  <XIcon size={32} round />{" "}
                </TwitterShareButton>

                {/* WhatsApp */}
                <WhatsappShareButton
                  url={
                    window.location.origin +
                    `/share/${AccDetails?.platform}/${AccDetails?.login_id}`
                  }
                  title={""}
                >
                  <WhatsappIcon size={32} round />
                </WhatsappShareButton>

                {/* LinkedIn */}
                <LinkedinShareButton
                  url={
                    window.location.origin +
                    `/share/${AccDetails?.platform}/${AccDetails?.login_id}`
                  }
                  title={""}
                >
                  <LinkedinIcon size={32} round />
                </LinkedinShareButton>

                {/* Telegram */}
                <TelegramShareButton
                  url={
                    window.location.origin +
                    `/share/${AccDetails?.platform}/${AccDetails?.login_id}`
                  }
                  title={""}
                >
                  <TelegramIcon size={32} round />
                </TelegramShareButton>

                {/* Reddit */}
                <RedditShareButton
                  url={
                    window.location.origin +
                    `/share/${AccDetails?.platform}/${AccDetails?.login_id}`
                  }
                  title={""}
                >
                  <RedditIcon size={32} round />
                </RedditShareButton>

                {/* Email */}
                <EmailShareButton
                  url={
                    window.location.origin +
                    `/share/${AccDetails?.platform}/${AccDetails?.login_id}`
                  }
                  subject={""}
                  body={
                    window.location.origin +
                    `/share/${AccDetails?.platform}/${AccDetails?.login_id}`
                  }
                >
                  <EmailIcon size={32} round />
                </EmailShareButton>
              </div>
            )}
          </div>
        </div>
      </div>

      {mainTabination === 1 && (
        <ProgramObjectives
          PerformanceChart={performance_chart && performance_chart}
          AccountInfo={AccDetails && AccDetails}
          Statistics={
            TradeJournalNew &&
            TradeJournalNew.calculated_data &&
            TradeJournalNew.calculated_data
          }
          ProfitData={
            TradeJournalNew &&
            TradeJournalNew.profit_chart &&
            TradeJournalNew.profit_chart
          }
          Trades={
            TradeJournalNew && TradeJournalNew.data && TradeJournalNew.data
          }
          DrawDown={
            TradeJournalNew &&
            TradeJournalNew.drawdown_chart &&
            TradeJournalNew.drawdown_chart
          }
          refreshData={refreshData}
          setRefreshData={setRefreshData}
        />
      )}

      {mainTabination === 2 && (
        <AdvancedInsights
          AdvStats={accountInsights && accountInsights}
          data={
            TradeJournalNew &&
            TradeJournalNew.calculated_data &&
            TradeJournalNew.calculated_data
          }
          TradeJournalNew={TradeJournalNew}
          TradingHistory={
            TradeJournalNew && TradeJournalNew.data && TradeJournalNew.data
          }
          // TradedPairsSummary={TradedPairsSummary}
          // TradesLotsPerDay={tlPerDay}
          // LotsPerTrade={LotsPerTrade}
        />
      )}

      {/* {mainTabination === 3 && (
        <TradingJournal
          platform={CurrentPltform}
          TradingHistory={
            TradeJournalNew && TradeJournalNew.data && TradeJournalNew.data
          }
        />
      )} */}
      {mainTabination === 3 && (
        <NewTradingHistory
          TradingHistory={
            TradeJournalNew && TradeJournalNew.data && TradeJournalNew.data
          }
        />
      )}

      {mainTabination === 4 && <AccountAnalysis />}

      {mainTabination === 5 && <NewAccInfo GeneralInfo={AccDetails} />}
    </div>
  );
};

export default AccountMetric;
